import React from 'react';
import { Table } from 'react-bootstrap';

import Grade from '../../../types/Grade';
import Student from '../../../types/Student';
import StudentResults from '../../../types/StudentResults';

import TableHead from '../../common/ui/Table/Head';
import StudentsTableRow from './TableRow';

interface Props {
  students: Student[];
  grades: Record<number, Grade>;
  studentsResults: Record<number, StudentResults>;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;

  sortData: { column: string; descending: boolean };
  setSortData: (data: { column: string; descending: boolean }) => void;
}

const StudentsTable = ({
  students,
  grades,
  studentsResults,
  unauthorizedCallback,
  showError,
  sortData,
  setSortData,
}: Props) => {
  const studentsRows = students.map((student: Student) => (
    <StudentsTableRow
      key={student.id}
      student={student}
      studentResults={studentsResults[student.id]}
      grades={grades}
      unauthorizedCallback={unauthorizedCallback}
      showError={showError}
    />
  ));

  return (
    <Table responsive>
      <TableHead
        columns={[
          { label: 'ID', minWidth: '150px' },
          { label: 'Пол', minWidth: '100px' },
          { label: 'Возраст', minWidth: '150px' },
          { label: 'Класс', minWidth: '100px' },
          { label: 'Буква', minWidth: '100px' },
          { label: 'Сирота', minWidth: '120px' },
          { label: 'НЗ', minWidth: '80px' },
          { label: 'НС', minWidth: '80px' },
          { label: 'НОДА', minWidth: '100px' },
          { label: 'Прошёл', minWidth: '150px' },
          { label: 'КВЕРИПО', minWidth: '150px' },
          { label: 'ИРП', minWidth: '150px' },
          {
            label: 'Вероятность проявлений рискового поведения',
            minWidth: '200px',
          },
        ]}
        sortingBy={sortData.column}
        descending={sortData.descending}
        setSortData={setSortData}
      />

      <tbody>{studentsRows}</tbody>
    </Table>
  );
};

export default StudentsTable;
